import { ErrorHandler, NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/services/auth.service';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { AuthInterceptor } from './modules/auth/services/auth.interceptor';
import { CoreModule } from './core';
import { SharedModule } from './shared/shared.module';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { LocalizationService } from './shared/services/localization.service';
import * as Sentry from "@sentry/angular";
import { Router } from "@angular/router";
import { PermissionService } from './core/services/permission.service';
import { JwtService } from './core/services/jwt.service';

export function initPermissions(
  permSvc: PermissionService,
  auth: AuthService,
  jwtService: JwtService
) {
  let userId: string | null = null;
  const token = auth.getAccessToken();
  if (token) {
    userId = jwtService.getUserId(token);
  }

  return () => {
    return userId
      ? permSvc.loadPermissions(userId)
      : Promise.resolve();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    ClipboardModule,
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
    SweetAlert2Module.forRoot(),
    ToastrModule.forRoot({
      timeOut: 2000, // Display time (ms)
      positionClass: 'toast-bottom-left', // Position of the toast
      preventDuplicates: false, // Prevent duplicate toasts
      closeButton: true, // Show close button
      progressBar: true, // Show progress bar
      progressAnimation: 'increasing', // Progress bar animation type
      extendedTimeOut: 1000, // Extended display time (ms)
      tapToDismiss: true, // Click to dismiss
    }),
    CoreModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
      deps: [AuthService, LocalizationService, ToastrService, Router],
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initPermissions,
      deps: [PermissionService, AuthService, JwtService],
      multi: true
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
